import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import ArticleCard from "@/components/ArticleCard";
import { SEO } from "@/components/SEO";

export default function Category() {
  const { slug } = useParams();
  const [cat, setCat] = useState(null);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      api.get("/categories").then((r) => r.data.find((c) => c.slug === slug)),
      api.get("/articles", { params: { category: slug, limit: 30 } }),
    ]).then(([c, a]) => {
      setCat(c);
      setItems(a.data.items || []);
      setTotal(a.data.total || 0);
      setLoading(false);
    });
    window.scrollTo({ top: 0 });
  }, [slug]);

  if (loading) return <div className="container-editorial py-24 text-center text-[color:var(--text-muted)]">Loading section…</div>;

  const [lead, ...rest] = items;
  return (
    <>
      <SEO title={`${cat?.name || "Section"} · ITTV News`} description={cat?.description} type="website" />
      <div className="border-b" style={{ borderColor: "hsl(var(--border-hsl))" }}>
        <div className="container-editorial py-16 md:py-24 reveal">
          <div className="kicker text-[color:var(--accent)] mb-3">Section</div>
          <h1 className="font-serif text-6xl md:text-8xl font-bold tracking-tight leading-none" data-testid="category-title">{cat?.name}</h1>
          {cat?.description && <p className="mt-6 text-xl text-[color:var(--text-muted)] max-w-2xl">{cat.description}</p>}
          <div className="kicker mt-4 text-[color:var(--text-muted)]">{total} stories</div>
        </div>
      </div>

      <div className="container-editorial py-12">
        {items.length === 0 ? (
          <p className="text-center py-24 text-[color:var(--text-muted)]">No stories in this section yet.</p>
        ) : (
          <>
            <div className="grid md:grid-cols-12 gap-8 mb-16">
              <div className="md:col-span-8"><ArticleCard article={lead} size="lg" /></div>
              <div className="md:col-span-4">
                {rest.slice(0, 4).map((a) => <ArticleCard key={a.slug} article={a} size="sm" />)}
              </div>
            </div>
            <div className="grid md:grid-cols-3 gap-8">
              {rest.slice(4).map((a) => <ArticleCard key={a.slug} article={a} />)}
            </div>
          </>
        )}
      </div>
    </>
  );
}
